export const html:string = `
<div class="error-list" v-if="filtered_errors && filtered_errors.length > 0">
    <ul class="errors">
        <div v-for="error in filtered_errors" class="has-error">{{ error }}</div>
    </ul>
</div>
`;
